export const MENU_TYPE = {
  COCKPIT: 'COCKPIT',
  WANDA: 'WANDA',
  CHANNELS: 'CHANNELS',
  BUD: 'BUD',
  HANDOFF: 'HANDOFF',
  HEALTHCARE_MAP: 'HEALTHCARE_MAP',
  TERTIARY_INTENTION_MAP: 'TERTIARY_INTENTION_MAP',
  VIRTUAL_CLINIC: 'VIRTUAL_CLINIC',
  SECONDARY_ATTENTION: 'SECONDARY_ATTENTION',
  EITA: 'EITA',
  REALOD: 'REALOD',
  LOGOUT: 'LOGOUT'
}

export const VIDEOCALL_MENU = {
  BACKGROUND: 'BACKGROUND',
  TOGGLE_PICTURE_IN_PICTURE: 'TOGGLE_PICTURE_IN_PICTURE'
}

export const CHANNELS_MENU = {
  OPEN_SEARCH: 'OPEN_SEARCH',
  SHOW_CONFIG: 'SHOW_CONFIG',
  START_VIDEOCALL: 'START_VIDEOCALL',
  REDIRECT_CHAT: 'REDIRECT_CHAT',
  REDIRECT_TO_N2: 'REDIRECT_TO_N2',
  NEW_CLINICAL_RECORD: 'NEW_CLINICAL_RECORD',
  TOGGLE_HANDOFF: 'TOGGLE_HANDOFF'
}
